export default {
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: {
      siteShortName: 'Diquex',
      items: 'items',
      reportTip: 'Report tip',
      newGame: 'New game',
      menu: 'Menu',
      myCards: 'My items',
      myProfile: 'My profile',
      logout: 'Logout',
      person: 'Person',
      year: 'Year',
      thing: 'Thing',
      location: 'Location',
      level: 'Level',
      easy: 'Easy',
      medium: 'Medium',
      hard: 'Hard',
      rateThisItem: 'Rate this item',
      liked: 'I liked',
      didNotLike: 'I didn\'t like',
      mediator: 'Mediator',
      players: 'Players',
      hit: 'Hit',
      missed: 'Missed',
      choosePlayerNumbers: 'Choose player numbers',
      chooseLevel: 'Choose level',
      chooseTipsQuantity: 'Choose tips quantity',
      start: 'Start!',
      giveThePhoneToPlayer: 'Give the device for:',
      itsMe: 'It\'s me',
      rollback: 'Rollback',
      endGame: '<strong>End game!</strong> Congratulations for winner:',
      newCard: 'New item',
      save: 'Save',
      answer: 'Answer',
      itemType: 'Item type',
      tips: 'Tips',
      seeMyItems: 'See my items',
      alreadyAccount: 'Login',
      createAccount: 'Create account',
      email: 'Email',
      password: 'Password',
      nickname: 'Nickname',
      login: 'Login',
      close: 'Close',
      sourceData: 'Source data',
      createdAt: 'Created at',
      views: 'Views',
      upVotes: 'Up votes',
      downVotes: 'Down votes',
      disabled: 'disabled',
      pending: 'pending',
      active: 'active',
      accepted: 'accepted',
      refused: 'refused',
      left: 'left',
      owner: 'owner',
      next: 'Next',
      prev: 'Prev',
      areYouSure: 'Are you sure?',
      yes: 'Yes',
      no: 'No',
      editCard: 'Edit card',
      update: 'Update',
      cancel: 'Cancel',
      search: 'Search',
      cleanFilters: 'Clean filters',
      myGroups: 'My groups',
      removeGroup: 'Remove group',
      userAdd: 'Add a user, search by nickname or email',
      gameGroupName: 'Group name',
      or: 'or',
      randomPlayers: 'random players',
      itRequiresAtLeastThreePeopleInTheGroup: 'it requires at least three people in the group'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locales/index.js